import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Blog from '../../components/Blog/Blog';
import CheckOut from '../../components/CheckOut/CheckOut';
import CourseDetails from '../../components/CourseDetails/CourseDetails';
import Courses from '../../components/Courses/Courses';
import ErrorPage from '../../components/ErrorPage/ErrorPage';
import Faq from '../../components/Faq/Faq';
import Home from '../../components/Home/Home';
import Login from '../../components/Login/Login';
import Register from '../../components/Register/Register';
import CourseLayout from '../../layout/CourseLayout';
import Main from '../../layout/Main';
import PrivateRoute from './PrivateRoute';

export const routes = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        errorElement: <ErrorPage></ErrorPage>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/home',
                element: <Home></Home>
            },
            {
                path: '/courses',
                element: <CourseLayout></CourseLayout>,
                children: [
                    {
                        path: '/courses',
                        element: <Courses></Courses>,
                        loader: () => fetch('https://technology-beta.vercel.app/courses'),
                    },
                    {
                        path: '/courses/:id',
                        element: <CourseDetails></CourseDetails>,
                        loader: ({params}) => fetch(`https://technology-beta.vercel.app/courses/${params.id}`),
                    },
                ]
            },
            {
                path: '/login',
                element: <Login></Login>
            },
            {
                path: '/register',
                element: <Register></Register>
            },
            {
                path: '/checkout/:id',
                element: <PrivateRoute><CheckOut></CheckOut></PrivateRoute>,
                loader: ({params}) => fetch(`https://technology-beta.vercel.app/courses/${params.id}`)
            },
            {
                path: '/faq',
                element: <Faq></Faq>
            },
            {
                path: '/blog',
                element: <Blog></Blog>,
                loader : () => fetch('https://technology-beta.vercel.app/blog')
            },
        ]
    }
])


